import styled from 'styled-components';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const LogoText = styled.span<{ $size: 'small' | 'medium' | 'large' }>`
  font-family: var(--sk-font-mono);
  font-weight: 700;
  color: var(--sk-logo-color, var(--sk-text-primary));
  letter-spacing: 0.05em;
  text-decoration: none;
  font-size: ${props => {
    switch (props.$size) {
      case 'small': return '20px';
      case 'large': return '36px';
      default: return '26px';
    }
  }};
`;

const Logo = ({ size = 'medium', className }: LogoProps) => (
  <LogoText $size={size} className={className}>
    SCRAPEKING
  </LogoText>
);

export default Logo;
